import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import {reactTableText} from '../constants/configs';
import {i18nizeDate, numberWithCommas} from '../helpers/Utils';
import ReactTableSelectFilter from "../components/ReactTableSelectFilter";
import {keyBy, mapValues, omit} from "lodash";
import UserInfo from "../components/UserInfo";
import ReactTable from 'react-table';
import {store} from "../AppRenderer";
import Api from "../services/Api";

class AlertsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alerts: [],
      pages: -1,
      loading: false,
    };
    this.renderTypeFilter = this.renderTypeFilter.bind(this);
    this.renderSideFilter = this.renderSideFilter.bind(this);
    this.renderPairFilter = this.renderPairFilter.bind(this);
    this.renderStatusFilter = this.renderStatusFilter.bind(this);
  }

  fetchData = async state => {
    const {userId} = this.props;
    this.setState({loading: true});
    try {
      const offset = state.page * state.pageSize;
      const {data} = await Api.invoke(
        'GET',
        '/v2/admin-ui/alerts',
        null,
        {
          params: {
            offset,
            limit: state.pageSize,
            ...(state.filtered.length ? omit(mapValues(keyBy(state.filtered, 'id'), 'value'), 'timestamp') : null),
            ...(userId ? {userId} : null),
          }
        }
      );
      this.setState({
        alerts: data.rows,
        pages: Math.ceil(data.count / state.pageSize),
      });
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  renderTypeFilter({filter, onChange}) {
    const {t} = this.props;
    const options = [
      {label: t('all'), value: ''},
      {label: 'PRICE_AMOUNT_CHANGE', value: 'PRICE_AMOUNT_CHANGE'},
      {label: 'CHANGE24_PRICE_PERCENTAGE', value: 'CHANGE24_PRICE_PERCENTAGE'},
    ];
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={options}
    />;
  }

  renderSideFilter({filter, onChange}) {
    const {t} = this.props;
    const options = [
      {label: t('all'), value: ''},
      {label: 'LONG', value: 'LONG'},
      {label: 'SHORT', value: 'SHORT'},
    ];
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={options}
    />;
  }

  renderPairFilter({filter, onChange}) {
    const {t} = this.props;
    const options = store.getState().general.pairs.map(pair => ({
      value: pair.name, label: pair.name,
    }));
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={[
        {value: '', label: t('all')},
        ...options,
      ]}
    />;
  }

  renderStatusFilter({filter, onChange}) {
    const {t} = this.props;
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={[
        {value: '', label: t('all')},
        {value: 'CREATED', label: 'CREATED'},
        {value: 'STARTED', label: 'STARTED'},
        {value: 'TRIGGERED', label: 'TRIGGERED'},
        {value: 'STOPPED', label: 'STOPPED'},
      ]}
    />;
  }

  getColumns = t => [
    {
      Header: t('Type'),
      accessor: 'type',
      filterable: true,
      Filter: this.renderTypeFilter,
    },
    {
      Header: t('Pair'),
      accessor: 'pair',
      width: 150,
      filterable: true,
      Filter: this.renderPairFilter,
      Cell: props => <span>{props.value ? props.value : t('all')}</span>,
    },
    {
      Header: t('Direction'),
      accessor: 'side',
      width: 120,
      filterable: true,
      Filter: this.renderSideFilter,
      Cell: props => <span>{props.value ? props.value : "---------"}</span>,
    },
    {
      Header: t('Amount'),
      accessor: 'value',
      width: 180,
      Cell: props => {
        const {type} = props.original;
        if (type === "PRICE_AMOUNT_CHANGE") {
          return (
            <span className="text-one">
              {`${numberWithCommas(Number(props.value))}`}
            </span>
          );
        }
        return (
          <span dir="ltr" className="text-one">
            {`${numberWithCommas(Number(props.value))}%`}
          </span>
        );
      },
    },
    {
      Header: t('Status'),
      accessor: 'status',
      width: 140,
      filterable: true,
      Filter: this.renderStatusFilter,
    },
    {
      Header: t('Start Date'),
      accessor: 'createdAt',
      width: 140,
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
    },
    {
      Header: t('End Date'),
      accessor: 'expireAt',
      width: 140,
      Cell: props => <span>{props.value ? i18nizeDate(props.value) : "---------"}</span>,
    },
    {
      Header: t('Activation Date'),
      accessor: 'triggeredAt',
      width: 140,
      Cell: props => <span>{props.value ? i18nizeDate(props.value) : "---------"}</span>,
    },
    {
      Header: t('Creator'),
      accessor: 'userId',
      Cell: props => {
        return (
          <UserInfo
            id={props.value}
            onClick={() => {this.props.history.push('/dashboard/users/' + props.value);}}
            textColor="text-success"
            label={t('User')}
            type="USER"
          />
        );
      },
      width: 80,
      show: !this.props.userId,
    },
  ];

  render() {
    const {t, userId} = this.props;
    const {alerts, pages, loading} = this.state;
    return (
      <ReactTable
        manual
        ref={el => {this.table = el;}}
        className="-highlight"
        data={alerts}
        pages={pages}
        loading={loading}
        sortable={false}
        resizable={true}
        onFetchData={this.fetchData}
        columns={this.getColumns(t)}
        defaultPageSize={userId ? 10 : 25}
        style={{width: '100%'}}
        {...reactTableText}
      />
    );
  }
}

export default withTranslation()(AlertsList);
